import React, { Component } from 'react'
import { Progress } from 'antd';

export class GradProcesBar extends Component {
  render() {
    return (
      <div className="grad-progres-bar">
        <Progress
      strokeColor={{
        from: '#EDDE5D',
        to: '#F09819',
      }}
      percent={100}
      status="active"
      strokeWidth={10}
      showInfo={false}
    />
      </div>
    )
  }
}

export default GradProcesBar
